import React, { useCallback, useMemo } from 'react';
import MappingTableRow from '../../TableRow';
import ChaserStyledSelect from '../../../../../../components/ChaserStyledSelect';
import { useReadOnly } from '../../readOnlyContext';

export const getConsumedColumns = value => {
  return {
    [value?.columnId]: true,
  };
};

export const useAvailableColumnsAsOptions = availableColumns => {
  const values = useMemo(
    () =>
      Object.entries(availableColumns)
        .filter(column => column[1].available)
        .map(column => column[0]),
    [availableColumns],
  );

  const options = useMemo(
    () => values.map(v => ({ value: v, label: availableColumns[v]?.label || v })),
    [values, availableColumns],
  );

  return options;
};

export const MappingTypeSimpleBase = ({
  value,
  availableColumns,
  onChange,
  required,
  disabled,
}) => {
  const options = useAvailableColumnsAsOptions(availableColumns);

  const valueAsOption = useMemo(
    () =>
      value?.columnId
        ? {
            value: value.columnId,
            label: availableColumns[value.columnId]?.label || value.columnId,
          }
        : null,
    [availableColumns, value],
  );

  const onColumnChange = useCallback(
    option => {
      onChange(!option?.value ? null : { columnId: option.value });
    },
    [onChange],
  );

  const readOnly = useReadOnly();

  return (
    <ChaserStyledSelect
      required={required}
      isDisabled={disabled || readOnly}
      onChange={onColumnChange}
      value={valueAsOption}
      options={options}
      isClearable
    />
  );
};

const MappingTypeSimple = ({ field, value, availableColumns, onChange }) => {
  return (
    <MappingTableRow field={field}>
      <MappingTypeSimpleBase
        value={value}
        availableColumns={availableColumns}
        onChange={onChange}
        required={field.required}
      />
    </MappingTableRow>
  );
};

export const Component = MappingTypeSimple;
